import React from 'react';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';

const StyledModalBody = styled(Modal.Body)`
  height: 270px;
`;

const StyledModalFooter = styled(Modal.Footer)`
  justify-content: normal;
  display: block;
`;

export default function Button({
  show,
  handleClose,
  heading,
  body,
  footer,
  ...props
}) {
  return (
    <Modal show={show} onHide={handleClose} {...props}>
      {heading && (
        <Modal.Header closeButton>
          <Modal.Title>{heading}</Modal.Title>
        </Modal.Header>
      )}
      {body && <StyledModalBody>{body}</StyledModalBody>}
      {footer && <StyledModalFooter>{footer}</StyledModalFooter>}
    </Modal>
  );
}
